export function expectedShipDate(now=new Date()) {
  const parts=Object.fromEntries(new Intl.DateTimeFormat('en-GB',{timeZone:'Europe/Sofia',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(now).filter(p=>p.type!=='literal').map(p=>[p.type,p.value]));
  const date=new Date(Date.UTC(Number(parts.year),Number(parts.month)-1,Number(parts.day)));
  let days=0;
  while(days<7) {
    date.setUTCDate(date.getUTCDate()+1);
    if(date.getUTCDay()!==0&&date.getUTCDay()!==6) days++;
  }
  return date;
}
export function updateSourcedDates(root=document,now=new Date()) {
  const date=expectedShipDate(now);
  const en=document.documentElement.lang.toLowerCase().startsWith('en');
  const day=String(date.getUTCDate()).padStart(2,'0');
  const month=String(date.getUTCMonth()+1).padStart(2,'0');
  const months=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  const formatted=en?day+' '+months[date.getUTCMonth()]+' '+date.getUTCFullYear():day+'.'+month+'.'+date.getUTCFullYear();
  root.querySelectorAll('[data-rt-sourced-date]').forEach(element=>{
    const message=element.dataset.rtSourcedMessage;
    if(!message)return;
    const label=element.dataset.rtSourcedDateLabel;
    element.textContent=message+(label?' '+label.replace('__DATE__',formatted):'');
    element.hidden=false;
  });
}
if(typeof document!=='undefined'){
  updateSourcedDates();
  document.addEventListener('shopify:section:load',event=>updateSourcedDates(event.target));
  window.addEventListener('pageshow',()=>updateSourcedDates());
}
